import { Turnstile } from "@marsidev/react-turnstile";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

export const CaptchaWidget = ({ onVerify }) => {
  return (
    <div className="captcha-container" style={{ margin: "1rem 0", maxWidth: "100%", overflow: "hidden" }}>
      <Turnstile
        siteKey={SITE_KEY}
        onSuccess={(token) => onVerify(token)}
        onError={() => onVerify(null)}
        onExpire={() => onVerify(null)}
        options={{ theme: "auto" }} // môže byť 'light' alebo 'dark'
      />
    </div>
  );
};
